<template>
  <div>
    <Form
      :create="true"
      :description-title="'Registre uma nova avaliação'"
    >
      <CreateButton
        @click="registerSector()"
        :icon="PhCloudCheck"
        :label="'Cadastrar'"
      />
    </Form>
  </div>
</template>

<script setup>
import CreateButton from '@/components/Buttons/Create.vue'
import Form from '../components/RegisterForm.vue'
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField
} from '@/helpers/formFieldsHandler'
import { showToast as toast } from '@/helpers/UseToasts'
import { dataExtinguisher } from '../store'
import { storeApp } from '@/store'
import { onBeforeMount } from 'vue'
import * as yup from '@/validator'
import { PhCloudCheck } from '@phosphor-icons/vue'
import ExtinguisherService from '../service/extinguisher.service'

const store = dataExtinguisher.state
const appStore = storeApp.state

const schema = yup.object().shape({
  form: yup.object().shape({
    title: yup.string().required('Informe um titulo').label('Titulo'),
    min_grade_required: yup.number().required('Informe a pontuação minima'),
    max_grade: yup.number().required('Informe a nota máxima'),
    max_attempts: yup.number().required('Informe o numero de tentativas'),
    event_id: yup.number().required('Informe um treinamento')
  })
})

async function registerSector () {
  appStore.loading = true

  cleanAllFormFields()
  const validate = await validateFormField(schema, store)

  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  await ExtinguisherService.createAssessment(store.form)
    .then((res) => {
      appStore.loading = false

      toast('Aviso', 'Prova adicionada com sucesso', 'success')

      dataExtinguisher.dispatch('resetForm')
    })
    .catch((err) => {
      appStore.loading = false

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast('Aviso', err.response.data.message, 'error')
      }

      return toast('Aviso', 'Algo deu errado ao registrar documento', 'error')
    })
}

onBeforeMount(async () => {
  appStore.loading = true
  dataExtinguisher.commit('RESET_FORM')
  dataExtinguisher.dispatch('setBackComponent', 'SectorForm')
  dataExtinguisher.dispatch('getComboQuestion')
  appStore.loading = false
})
</script>
